import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'conditions',
    query: { id: '' },
    component: HomeView
  },
  {
    path: '/DisclosureTracking',
    name: 'disclosuretracking',
    query: { id: '' },
    component: () => import('../views/DisclosureTracking.vue')
  },
  {
    path: '/Documents',
    name: 'documents',
    query: { id: '' },
    component: () => import('../views/DocumentsView.vue')
  },
  { 
    path: '/FileManager',
    name: 'filemanager',
    query: { id: '' },
    component: () => import('../views/FileManagerView.vue')
  },
  {
    path: '/ConsumerPortal',
    name: 'consumerportal',
    query: { id: '', swiftprocessing: '' },
    component: () => import('../views/ConsumerPortalView.vue')
  },
  {
    path: '/Admin',
    name: 'admin',
    query: { id: '' },
    component: () => import('../views/admin.vue')
  },
  {
    path: '/PostClose',
    name: 'postclose',
    query: { id: '' },
    component: () => import('../views/PostClose.vue')
  },
  {
    path: '/Duplicate',
    name: 'duplicate',
    query: { id: '' },
    component: () => import('../views/DuplicateLoan.vue')
  },
  {
    path: '/LoanTasks',
    name: 'loantasks',
    query: { id: '' },
    component: () => import('../views/InternalTasks.vue')
  },
  {
    path: '/InternalTasks',
    redirect: to => {
      return { path: '/LoanTasks', query: to.query }
    }
  },
  {
    path: '/Closing',
    name: 'closing',
    query: { id: '' },
    component: () => import('../views/ClosingView.vue')
  },
  {
    path: '/SwiftData',
    name: 'swiftdata',
    query: { id: '' },
    component: () => import('../views/SwiftData.vue')
  },
  {
    path: '/SwiftAlerts',
    name: 'swiftalerts',
    query: { id: '' },
    component: () => import('../views/SwiftAlerts.vue')
  },
  {
    path: '/ScenarioManager',
    name: 'scenariomanager',
    query: { id: '' },
    component: () => import('../views/ScenarioManager.vue')
  },
   {
    path: '/screenshare',
    name: 'screenshare',
    query: { id: '' },
    component: () => import('../views/ScreenShare.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router
